export const SCROLLABLE_BY_WHEEL_REF_NAME = 'scrollable-by-wheel';

export default {
  SCROLLABLE_BY_WHEEL_REF_NAME,
};
